module.exports = __webpack_public_path__ + "static/media/chat.17e39037.png";